import styled from "styled-components";

export const InputCalendarContainer = styled.div`
  .react-datepicker-wrapper {
    width: 100%;
    position: relative;
  }

  img {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 24px;
  }
`;
